import * as React from 'react';
import SubCard from 'ui-component/cards/SubCard';
import SideMenu from './Components/Approval Ds/SideMenu';
import { Divider } from '@mui/material';

const ApprovalDsLayout=()=>{
return(
    <SubCard  sx={{height:'80vh',overflowX:'scroll'}} title='DS & MDS Request'>
          <Divider sx={{mt:'-20px'}}/>
        <SideMenu />
    </SubCard>
)
}

export default ApprovalDsLayout